import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { LocalBasketItem } from '../customer/basket/basket-item.decorator';
@Component({
    selector: 'basket-notification-item',
    templateUrl: './basket-notification-item.html',
    standalone: true,
    imports: [NgClass, RouterLink, ImageModule, PriceComponent, AttributeLabelPipe, OptionLabelPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketNotifiactionItemComponent extends BasketItemComponentDef<LocalBasketItem> {
    get image(): string | undefined {
        return this.item!.data.am_giftcard_image_url || this.product?.data?.image;
    }
}
